import React from "react";
import Typography from "@material-ui/core/Typography";
import {
  Dialog,
  DialogContent,
  Box,
  DialogActions,
  Button,
} from "@material-ui/core";

const LeaveConfirmationModal = ({ modalOpen, onConfirm, onClose }) => {
  return (
    <Dialog open={modalOpen} onClose={onClose}>
      <DialogContent>
        <Box textAlign="center" mt={1} mb={1} pl={1} pr={1}>
          <Box mb={1} />
          <Typography variant="h6">
            Are you sure you want to leave this page?
          </Typography>
          <Box mb={1} />
          <Typography variant="caption">
            Your progress will not be saved
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box flex="2" />
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Yes
        </Button>
        <Box flex="1" />
        <Button variant="outlined" color="primary" onClick={onClose}>
          No
        </Button>
        <Box flex="2" />
      </DialogActions>
    </Dialog>
  );
};

export default LeaveConfirmationModal;
